module.exports = __webpack_public_path__ + "img/parents.3a439d2d.svg";